import { PackageType } from '@fi-app/billing/package-type';
import { CurrencyType } from '@fi-app/customer-billing/customer-billing-price/currency-type';

export class CustomerBillingPriceArticleModel {
    Id: number = undefined;
    ArticleId: number = undefined;
    Name: string = undefined;
    IsModule = false;
    ModuleId: number = undefined;
    PricePerType = 0;
    AffectedByDiscount = true;
    DisplayAsOption = true;
    AllowSelectLevel = false;
    AllowLevelSelectOption = false;
    AllowLocalCharges = true;
    Prices: ICustomerBillingPriceModel[] = [];
    CurrencyTypes: CurrencyType[];
    Labels: IBillingPriceArticleLabel[] = [];
    PricePer;
    ModuleNameTextId;

    constructor(data?) {
        if (data) this.Initialize(data);
    }

    Initialize(data) {
        Object.assign(this, data);
    }
}

export interface ICustomerBillingPriceModel {
    UsageLevel: PackageType;
    AllowedUsage: number;
    PriceValues: ICustomerBillingPriceValueModel[];
}

export interface ICustomerBillingPriceValueModel {
    Price: number;
    CurrencyType: CurrencyType;
}

export interface IBillingPriceListItemModel {
    ArticleId: number;
    Name: string;
    PricePer: number;
    ChildItems: IBillingPriceListItemModel[];
    PriceValues: ICustomerBillingPriceValueModel[];
}

export interface IBillingPriceArticleLabel {
    Language: number;
    Name: string;
    Description: string;
}
